import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class RemoveNpvrTask extends AbstractRequestTask {
  constructor(params) {
    super();

    this.params = params;
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");
    return `${http}${url}/services/recordings/v1/delete`;
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    delete this.params.user_token;
    return Object.assign({}, params, this.params);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default RemoveNpvrTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/npvr/RemoveNpvrTask.js